export default __webpack_public_path__ + "static/media/thienhy.e73a7880.png";